import { InjectionToken } from '@angular/core';
import { TooltipData } from './tooltip-data.interface';

export const TOOLTIP_DATA = new InjectionToken<TooltipData>('TOOLTIP_DATA');
